import { render, staticRenderFns } from "./ElementoForm.vue?vue&type=template&id=fbb4309e"
import script from "./ElementoForm.vue?vue&type=script&lang=ts"
export * from "./ElementoForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports